import { ListingStrategyRun } from '../../../../types/api'

export function resolveRunState(run: ListingStrategyRun): string {
  if (!run) return null
  if (!run?.currentStep && run.running) return 'Waiting to start'
  if (+run.currentStep?.rank + 1 === run.totalSteps) return 'Finished'
  if (!run?.running) return 'Paused'

  return 'Running'
}
